module.exports = __webpack_public_path__ + "static/media/pig.d6de391b.svg";